import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import { Link, useLocation } from "react-router-dom";
import Repo from "../../Utility/Repo";
import ModalComponent from "../../Components/ModalComponent";
import Loader from "../../Components/Loader";
import { useEffect, useState, useContext } from "react";
import { TokenContext } from "../../Components/TokenContext";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function ListServices(props) {
  const apiToken = useContext(TokenContext);
  const [servicesList, setServicesList] = useState();
  const [serviceId, setServiceId] = useState();
  const [isOpen, toggleModal] = useState(false);
  const [loading, setLoading] = useState(true);
  let query = useQuery();

  useEffect(() => {
    if (apiToken) {
      setLoading(false);
      Repo.getServices(apiToken)
        .then((response) => {
          setServicesList(response.data);
          setLoading(true);
        })
        .catch((error) => {
          console.log(error);
          setLoading(true);
        });
    }
  }, []);

  const deleteService = () => {
    Repo.deleteService(apiToken, serviceId)
      .then((response) => {
        if (response.status == 200) {
          window.location.reload();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>

      <h1>Lista servizi</h1>
        <div className="clearfix col-lg-8 py-lg-2">
          <p>Tutti i servizi disponibili</p>
          </div>

      <div className="row mt-2 text-right">
        <div className="col-lg-12 clearfix">
          <button
            type="button"
            className="btn btn-outline-primary float-right p-2"
            onClick={() =>
              (window.location.href =
                window.location.pathname + "/nuovo_servizio")
            }
          >
            <svg className="icon icon-primary">
              <use href={`${iconSprite}#it-plus-circle`} />
            </svg>{" "}
            <span className="align-middle">Nuovo servizio</span>
          </button>
        </div>
      </div>
      <table className="table table-hover">
        <thead>
          <tr>
            <th scope="col">Codice</th>
            <th scope="col">Titolo</th>
            <th scope="col">Descrizione</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          {servicesList &&
            servicesList.length > 0 &&
            servicesList.map((x, index) => (
              <tr key={index}>
                <th scope="row">{x.code} </th>
                <td>{x.name}</td>
                <td className="col-7">{x.description}</td>
                <td className="text-right">
                  <Link to={"/servizi/visualizza_servizio?id=" + x.id}>
                    <button
                      className="btn btn-outline-primary p-1"
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Dettaglio"
                    >
                     <svg className="icon icon-primary">
                      <use href={`${iconSprite}#it-search`} />
                    </svg>
                    </button>
                  </Link>
                  {/* <Link to={"/lista_bandi?id=" + x.id + "&name=" + x.name}>
                    <button
                      className="btn btn-outline-primary p-1 ml-1"
                      type="button"
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Visualizza le sessioni del servizio selezionato"
                    >
                      <svg className="icon icon-primary">
                        <use href={`${iconSprite}#it-search`} />
                      </svg>
                    </button>
                  </Link>
                  <Link to={"/servizi/modifica_servizio?id=" + x.id}>
                    <button
                      className="btn btn-outline-primary p-1 ml-1"
                      type="button"
                    >
                      <svg className="icon icon-primary">
                        <use href={`${iconSprite}#it-pencil`} />
                      </svg>
                    </button>
                  </Link> */}
                  <button
                    className="btn btn-outline-danger p-1 ml-1"
                    type="button"
                    onClick={() => {
                      toggleModal(!isOpen), setServiceId(x.id);
                    }}
                  >
                    <svg className="icon icon-danger">
                      <use href={`${iconSprite}#it-delete`} />
                    </svg>
                  </button>
                </td>
              </tr>
            ))}
        </tbody>
      </table>

      <ModalComponent
        toggleModal={toggleModal}
        isOpen={isOpen}
        header="Elimina Servizio"
        body="Confermi di voler eliminare questo servizio? L'operazione sarà possibile solo se non sono presenti servizi associati"
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => deleteService()}
      ></ModalComponent>
      {!loading && <Loader></Loader>}
    </>
  );
}

export default ListServices;
